function status(value: number) {
  const labelStatus: { [e: number]: string } = {
    0: 'Normal',
    1: 'Low',
    2: 'High',
  };
  return labelStatus[value];
}

export default status;
